import { UAParser } from "ua-parser-js";

export const isMacOS = new UAParser(navigator.userAgent).getOS().name === "macOS";
export const modKey = isMacOS ? "⌘" : "Ctrl";
